const featureFlags = {
  get hideCallIndicator() {
    return !!window.__amp_feature_flags.hide_call_indicator;
  },
  get productAnnouncements() {
    return !!window.__amp_feature_flags.product_announcements;
  },
  get dynamicTips() {
    return (
      !!window.__amp_feature_flags.dynamic_tip_on_summary ||
      !!window.__amp_feature_flags.dynamic_tip_on_data_collection ||
      !!window.__amp_feature_flags.dynamic_tip_on_quotes ||
      !!window.__amp_feature_flags.life_insurance_pitch
    );
  },
  get dynamicTipOnSummary() {
    return !!window.__amp_feature_flags.dynamic_tip_on_summary;
  },
  get dynamicTipOnDataCollection() {
    return !!window.__amp_feature_flags.dynamic_tip_on_data_collection;
  },
  get dynamicTipOnQuotes() {
    return !!window.__amp_feature_flags.dynamic_tip_on_quotes;
  },
  get lifeInsurancePitch() {
    return !!window.__amp_feature_flags.life_insurance_pitch;
  },
  get hideSensitiveSataForPnc() {
    return !!window.__amp_feature_flags.hide_sensitive_data_for_pnc;
  },
  get cstGuidedSellingExperience() {
    return !!window.__amp_feature_flags.cst_guided_selling_experience;
  },
  get requiredDocsForPolicy() {
    return !!window.__amp_feature_flags.required_docs_for_policy;
  },
  get policyActions() {
    return !!window.__amp_feature_flags.policy_actions;
  },
  get coverageConfigs() {
    return !!window.__amp_feature_flags.coverage_configs;
  },
  get experimentalStuff() {
    return !!window.__amp_feature_flags.experimental_stuff;
  },
  get homePolicyTypeOverride() {
    return !!window.__amp_feature_flags.home_policy_type_override;
  },
  get disablePolicyEditFields() {
    return !!window.__amp_feature_flags.disable_policy_edit_fields;
  },
  get newPolicyStatusDisplay() {
    return !!window.__amp_feature_flags.new_policy_status_display;
  },
  get salesDashboardColumnsVisibility() {
    return !!window.__amp_feature_flags.sales_dashboard_columns_visibility;
  },
  get attachCustomerVehiclesToLead() {
    return !!window.__amp_feature_flags.attach_customer_vehicles_to_lead;
  },
  get policyNumberUnavailable() {
    return !!window.__amp_feature_flags.policy_number_unavailable;
  },
  get nonAdmittedCarrierQuotes() {
    return !!window.__amp_feature_flags.non_admitted_carrier_quotes;
  },
  get sendDocuments() {
    return !!window.__amp_feature_flags.send_documents;
  },
  get resetEligibilityOnNewEngagement() {
    return !!window.__amp_feature_flags.reset_eligibility_on_new_engagement;
  }
};

export default featureFlags;
